export const FINANCE_QUOTES = [
  "Paranı yönetmek, geleceğine bugünden yön vermektir.",
  "Küçük birikimler, büyük özgürlüklerin sessiz başlangıcıdır.",
  "Bütçe, paranı kısıtlamaz; ona bir amaç verir.",
  "Kazancın kadar, kazancını nasıl yönettiğin de önemlidir.",
  "Finansal huzur, neye sahip olduğundan çok neyi kontrol ettiğinle ilgilidir.",
  "Her lira bir tercih, her tercih geleceğe bırakılan bir izdir.",
  "Tasarruf, bugünden vazgeçmek değil yarını seçmektir.",
  "Ölçemediğin nakit akışını yönetemezsin.",
  "Düzenli takip, finansal sürprizlerin en iyi ilacıdır.",
  "Borcu azaltmak, gelecekteki gelirine alan açmaktır.",
  "Birikim bir miktar değil, sürdürülen bir alışkanlıktır.",
  "Finansal disiplin, özgürlüğün görünmeyen temelidir.",
  "Önce hedefini belirle, sonra paranı o hedefe yönlendir.",
  "Küçük harcamalar görünmez olabilir; toplamları asla değildir.",
  "Nakit akışını bilen, kararlarını daha sakin verir.",
  "Bugünün planı, yarının maddi rahatlığıdır.",
  "Gelir geçici olabilir, iyi para alışkanlıkları kalıcıdır.",
  "Her ay kendine ödeme yapmayı unutma: birikim bunun adıdır.",
  "Finansal güç, çok kazanmaktan önce bilinçli yönetmekle başlar.",
  "Planlanmış para, kaybolmadan amacına ulaşır.",
  "Acil durum fonu, belirsizlik karşısındaki sessiz güvencedir.",
  "Bütçendeki her kalem, önceliklerinin bir yansımasıdır.",
  "Harcamadan önce düşünmek, kazandıktan sonra pişman olmaktan ucuzdur.",
  "Sade bir finans planı, karmaşık bir borçtan iyidir.",
  "İstikrar, yatırımın en güçlü ama en az konuşulan ortağıdır.",
  "Paranın yönünü sen belirlemezsen, alışkanlıkların belirler.",
  "Finansal hedefler takvimle buluştuğunda plana dönüşür.",
  "Bir borcun kapanması, yeni bir ihtimalin açılmasıdır.",
  "Varlık büyütmek sabır, korumak dikkat ister.",
  "Bugün kaydettiğin her hareket, yarın daha iyi bir karar olur.",
  "Nakit akışı, finansal hayatın nabzıdır.",
  "Gerçek zenginlik, seçeneklere sahip olabilmektir.",
  "Bütçe yapmak, kendine hayır demek değil önceliklerine evet demektir.",
  "Düzenli birikim, motivasyondan daha güvenilir bir sistemdir.",
  "Finansal başarı büyük sıçramalardan çok doğru tekrarlarla kurulur.",
  "Hedefsiz para harcanır, hedefli para büyür.",
  "Gelirini artırırken yaşam maliyetini bilinçli tut.",
  "Faiz küçük görünür; zamanla büyük konuşur.",
  "Riskini tanımadan getiriye güvenme.",
  "İyi yatırım önce bilgiye, sonra zamana dayanır.",
  "Paranı takip etmek, kendini yargılamak değil kendini tanımaktır.",
  "Finansal netlik, zihinsel ferahlık getirir.",
  "Gereksiz bir harcamayı ertelemek, hedefini erkene almaktır.",
  "Her ödeme günü, planını güçlendirmek için yeni bir fırsattır.",
  "Birikimin en iyi zamanı dün, ikinci en iyi zamanı bugündür.",
  "Para kararlarında hızdan çok tutarlılık kazandırır.",
  "Kredi limiti, harcama hedefi değildir.",
  "Kazancın büyüdükçe planın da büyüsün, masrafların değil.",
  "Finansal güven, hazırlanmış olmaktan doğar.",
  "Bir hedefi küçük aylık adımlara bölmek, onu ulaşılabilir kılar.",
  "Paranın değeri, sana kazandırdığı özgürlükle ölçülür.",
  "Kontrollü harcama, hayatın tadını azaltmaz; pişmanlığı azaltır.",
  "Bütçedeki boşluklar, gelecekteki fırsatlara yer açar.",
  "İyi bir finans planı hem bugünü yaşatır hem yarını korur.",
  "Kendine verdiğin en değerli sözlerden biri, finansal disiplin sözüdür.",
  "Birikim hedefini otomatikleştir, iradene daha az yük bırak.",
  "Finansal kararlarında duygunu dinle, hesabını kontrol et.",
  "Görünür hedefler, görünmez harcamaları azaltır.",
  "Gelir bir araçtır; yönünü değerlerin belirlemelidir.",
  "Her ayın sonunda rakamlar sana bir hikâye anlatır.",
  "Paranı bölüştürmek, önceliklerini düzenlemektir.",
  "Finansal özgürlük bir varış noktası değil, günlük bir uygulamadır.",
  "Geciken planın maliyeti, geciken ödemenin faizi kadar gerçek olabilir.",
  "Az ama düzenli ilerlemek, çok ama düzensiz ilerlemekten güçlüdür.",
  "Nakit rezervi, fırsat geldiğinde hareket alanı sağlar.",
  "İhtiyaç ile isteği ayırmak, bütçenin en değerli becerisidir.",
  "Bir finansal kararın gerçek maliyeti, vazgeçtiğin diğer seçenektir.",
  "Rakamlarla yüzleşmek, kontrolü geri almanın ilk adımıdır.",
  "Paranı koruyan sınırlar, hedeflerini büyüten alanlar yaratır.",
  "Dengeli finans, bugünün konforuyla yarının güvenini buluşturur.",
  "Yatırım yapmadan önce zaman ufkunu, harcamadan önce amacını bil.",
  "Finansal alışkanlıkların, gelirinden daha uzun süre seninle kalır.",
  "En iyi bütçe, sürdürebildiğin bütçedir.",
  "Hesabını sık kontrol et, hedefini seyrek değiştirme.",
  "Birikim oranındaki küçük artış, yıllar içinde büyük fark yaratır.",
  "Plan dışı her harcama kötü değildir; görünmeyen her harcama risktir.",
  "Finansal sakinlik, hazırlık ile belirsizlik arasındaki dengedir.",
  "Paranın kontrolü sende olduğunda zamanın da daha çok sana ait olur.",
  "Bugünün bilinçli tercihi, yarının güçlü bilançosudur.",
  "Finansını sadeleştir; kararlarını güçlendir.",
];

const LAST_QUOTE_KEY = "flum-last-finance-quote";

export const getRandomFinanceQuote = () => {
  const previous = Number.parseInt(window.sessionStorage.getItem(LAST_QUOTE_KEY), 10);
  const hasPrevious = Number.isInteger(previous) && previous >= 0 && previous < FINANCE_QUOTES.length;
  const offset = Math.floor(Math.random() * (FINANCE_QUOTES.length - (hasPrevious ? 1 : 0)));
  const index = hasPrevious && offset >= previous ? offset + 1 : offset;
  window.sessionStorage.setItem(LAST_QUOTE_KEY, String(index));
  return FINANCE_QUOTES[index];
};
